<template>
	<div id="app">
		<main>
			<router-view></router-view>
		</main>
	</div>
</template>

<script>

export default {
	name: 'app',
};
</script>

<style lang="scss">
* {
	box-sizing: border-box;
}

body {
	margin: 0;
}

#app {
	font-family: map-get($fonts, regular);
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: map-get($colors, white);
	min-width: 320px;
}

main {
	text-align: center;
}

header {
	margin: 0;
	height: 56px;
	padding: 0 16px 0 24px;
	background-color: #35495E;
	color: #ffffff;
}

button {
	background-color: transparent;
	border: none;
	cursor: pointer;
	outline: none;
	max-width: 100%;

	&:focus {
		outline: none;
	}
}

.row {
	display: flex;
	flex: 1 1 auto;
	flex-direction: row;
	flex-wrap: wrap;

	&.align-end {
		align-items: flex-end;
	}

	&.align-center {
		align-items: center;
	}

	&.align-start {
		align-items: start;
	}
	
	&.justify-end {
		justify-content: flex-end;
	}

	&.justify-center {
		justify-content: center;
	}

	&.justify-space-around {
		justify-content: space-around;
	}

	&.justify-space-between {
		justify-content: space-between;
	}

	&.justify-start {
		justify-content: start;
	}

	.col {
		&-12 {
			flex-basis: 100%;
			flex-grow: 0;
			max-width: 100%;

			&-md {
				@media (min-width: 960px) {
					flex-basis: 100%;
					flex-grow: 0;
					max-width: 100%;
				}
			}
		}

		&-11 {
			flex-basis: 91.66666666666666%;
			flex-grow: 0;
			max-width: 91.66666666666666%;

			&-md {
				@media (min-width: 960px) {
					flex-basis: 91.66666666666666%;
					flex-grow: 0;
					max-width: 91.66666666666666%;
				}
			}
		}

		&-10 {
			flex-basis: 83.33333333333334%;
			flex-grow: 0;
			max-width: 83.33333333333334%;

			&-md {
				@media (min-width: 960px) {
					flex-basis: 83.33333333333334%;
					flex-grow: 0;
					max-width: 83.33333333333334%;
				}
			}
		}

		&-9 {
			flex-basis: 75%;
			flex-grow: 0;
			max-width: 75%;

			&-md {
				@media (min-width: 960px) {
					flex-basis: 75%;
					flex-grow: 0;
					max-width: 75%;
				}
			}
		}

		&-8 {
			flex-basis: 66.66666666666666%;
			flex-grow: 0;
			max-width: 66.66666666666666%;

			&-md {
				@media (min-width: 960px) {
					flex-basis: 66.66666666666666%;
					flex-grow: 0;
					max-width: 66.66666666666666%;
				}
			}
		}

		&-7 {
			flex-basis: 58.333333333333336%;
			flex-grow: 0;
			max-width: 58.333333333333336%;

			&-md {
				@media (min-width: 960px) {
					flex-basis: 58.333333333333336%;
					flex-grow: 0;
					max-width: 58.333333333333336%;
				}
			}
		}

		&-6 {
			flex-basis: 50%;
			flex-grow: 0;
			max-width: 50%;

			&-md {
				@media (min-width: 960px) {
					flex-basis: 50%;
					flex-grow: 0;
					max-width: 50%;
				}
			}
		}

		&-5 {
			flex-basis: 41.66666666666667%;
			flex-grow: 0;
			max-width: 41.66666666666667%;

			&-md {
				@media (min-width: 960px) {
					flex-basis: 41.66666666666667%;
					flex-grow: 0;
					max-width: 41.66666666666667%;
				}
			}
		}

		&-4 {
			flex-basis: 33.33333333333333%;
			flex-grow: 0;
			max-width: 33.33333333333333%;

			&-md {
				@media (min-width: 960px) {
					flex-basis: 33.33333333333333%;
					flex-grow: 0;
					max-width: 33.33333333333333%;
				}
			}
		}

		&-3 {
			flex-basis: 25%;
			flex-grow: 0;
			max-width: 25%;

			&-md {
				@media (min-width: 960px) {
					flex-basis: 25%;
					flex-grow: 0;
					max-width: 25%;
				}
			}
		}

		&-2 {
			flex-basis: 16.666666666666664%;
			flex-grow: 0;
			max-width: 16.666666666666664%;

			&-md {
				@media (min-width: 960px) {
					flex-basis: 16.666666666666664%;
					flex-grow: 0;
					max-width: 16.666666666666664%;
				}
			}
		}

		&-1 {
			flex-basis: 8.333333333333332%;
			flex-grow: 0;
			max-width: 8.333333333333332%;

			&-md {
				@media (min-width: 960px) {
					flex-basis: 8.333333333333332%;
					flex-grow: 0;
					max-width: 8.333333333333332%;
				}
			}
		}
	}
}

.mr-1 {
	margin-right: 7px;
}

.mr-2 {
	margin-right: 14px;
}

.mr-3 {
	margin-right: 21px;
}

.mr-4 {
	margin-right: 42px;
}

.mr-5 {
	margin-right: 84px;
}

.mt-1 {
	margin-top: 7px;
}

.mt-2 {
	margin-top: 14px;
}

.mt-3 {
	margin-top: 21px;
}

.mt-4 {
	margin-top: 42px;
}

.mt-5 {
	margin-top: 84px;
}

.pl-1 {
	padding-left: 7px;
}

.pl-2 {
	padding-left: 14px;
}

.pl-3 {
	padding-left: 21px;
}

.pl-4 {
	padding-left: 42px;
}

.pl-5 {
	padding-left: 84px;
}

.pr-1 {
	padding-right: 7px;
}

.pr-2 {
	padding-right: 14px;
}

.pr-3 {
	padding-right: 21px;
}

.pr-4 {
	padding-right: 42px;
}

.pr-5 {
	padding-right: 84px;
}

.pt-1 {
	padding-top: 7px;
}

.pt-2 {
	padding-top: 14px;
}

.pt-3 {
	padding-top: 21px;
}

.pt-4 {
	padding-top: 42px;
}

.pt-5 {
	padding-top: 84px;
}

.text-center {
	text-align: center;
}

.text-left {
	text-align: left;
}

.text-right {
	text-align: right;
}

p {
	font-size: 20px;
	margin: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue